(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sean-education"] && !Shopify.designMode) return;
  try {
    function enhanceEducation(root) {
  if (root.dataset.enhanced) return;
  const record = root.querySelector('#education-accordion');
  if (!record) return;
  root.dataset.enhanced = 'true';
  const overview = record.querySelector(':scope > section');
  if (overview) {
    const details = document.createElement('details');
    details.className = 'sb-edu__approach';
    const summary = document.createElement('summary');
    summary.textContent = root.dataset.approach;
    overview.before(details);
    details.append(summary, overview);
  }
  const groups = [...record.querySelectorAll(':scope > details:not(.sb-edu__approach)')];
  const nav = root.querySelector('[data-nav]');
  const normalize = text => text.toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g,' ').trim();
  groups.forEach((group,index) => {
    group.id = 'education-subject-' + (index + 1);
    const summary = group.querySelector(':scope > summary');
    const title = summary.querySelector('span:first-child');
    const heading = document.createElement('h2');
    heading.textContent = title.textContent;
    title.replaceWith(heading);
    const link = document.createElement('a');
    link.href = '#' + group.id;
    const number = document.createElement('span');
    number.textContent = String(index + 1).padStart(2,'0');
    const label = document.createElement('span');
    label.textContent = heading.textContent;
    link.append(number,label);nav.append(link);
    const option = document.createElement('option');option.value = group.id;option.textContent = heading.textContent;
    root.querySelector('[data-subject]').append(option);
    const content = group.querySelector('.content');
    content.querySelectorAll('img').forEach(image => {
      if (!image.alt) image.alt = heading.textContent + ' — supporting image';
      image.loading = 'lazy';
    });
    content.querySelectorAll(':scope > h4').forEach(h => {
      if (!h.textContent.trim()) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'edu-topic';
      h.before(wrapper); wrapper.append(h);
      while (wrapper.nextElementSibling && wrapper.nextElementSibling.tagName !== 'H4') wrapper.append(wrapper.nextElementSibling);
    });
    content.querySelectorAll('.subsection').forEach(sub => {
      if (sub.querySelector('li')) return;
      sub.querySelectorAll(':scope > h4').forEach(h => {
        const entry = document.createElement('div');entry.className = 'edu-entry';
        h.before(entry);entry.append(h);
        while(entry.nextElementSibling && !['H3','H4'].includes(entry.nextElementSibling.tagName)) entry.append(entry.nextElementSibling);
      });
    });
    const units = [...content.querySelectorAll('li, .edu-entry, .edu-topic')].filter(e => !e.querySelector('li, .edu-entry'));
    units.forEach(unit => unit.dataset.searchText = normalize(unit.textContent));
    group.eduUnits = units;
    group.eduTitle = normalize(heading.textContent);
    group.eduText = normalize(content.textContent);
    group.open = index === 0;
    if(index === 0) group.classList.add('edu-academic');
    link.addEventListener('click', () => {
      if(input.value) {input.value='';filter();}
      group.open = true;
    });
  });
  const input = root.querySelector('#education-search');
  const status = root.querySelector('[data-status]');
  const initialStatus = status.textContent;
  const clear = root.querySelector('[data-clear]');
  let previousOpen = null;
  function filter() {
    const terms = normalize(input.value).split(' ').filter(Boolean);
    const match = text => terms.every(term => text.split(' ').some(word => word === term || (term.length >= 3 && word.startsWith(term))));
    if(terms.length && !previousOpen) previousOpen = groups.map(g => g.open);
    let visible = 0;
    groups.forEach(group => {
      const titleMatch = terms.length && match(group.eduTitle);
      const sectionMatch = !terms.length || titleMatch || match(group.eduText);
      group.hidden = !sectionMatch;
      if(sectionMatch) visible++;
      let unitMatches = 0;
      group.eduUnits.forEach(unit => {
        unit.hidden = !!terms.length && !titleMatch && !match(unit.dataset.searchText);
        if(!unit.hidden) unitMatches++;
      });
      group.querySelectorAll('.content > p, .content > h4').forEach(intro => {intro.hidden = !!terms.length && !titleMatch && unitMatches > 0;});
      group.querySelectorAll('.subsection,.edu-topic,ul').forEach(wrapper => {
        const units = group.eduUnits.filter(u => wrapper.contains(u));
        if(units.length) wrapper.hidden = units.every(u => u.hidden);
      });
      if(terms.length && sectionMatch) group.open = true;
      else if(!terms.length && previousOpen) group.open = previousOpen[groups.indexOf(group)];
    });
    if(!terms.length) previousOpen = null;
    status.textContent = terms.length ? root.dataset.results.replace('{count}',visible).replace('{total}',groups.length) : initialStatus;
    clear.hidden = !terms.length;
    root.querySelector('[data-empty]').hidden = visible !== 0;
    root.querySelector('.sb-edu__approach')?.toggleAttribute('hidden',!!terms.length);
  }
  const incomingSearch = new URLSearchParams(location.search).get('training');
  if(incomingSearch){input.value=incomingSearch;filter();}
  input.addEventListener('input',filter);
  root.querySelector('[data-subject]').addEventListener('change',event=>{
    const group = groups.find(g=>g.id===event.target.value);
    if(!group) return;
    input.value='';filter();group.open=true;group.scrollIntoView({block:'start'});
  });
  clear.addEventListener('click',()=>{input.value='';filter();input.focus();});
  root.querySelector('[data-expand]').addEventListener('click',()=>groups.filter(g=>!g.hidden).forEach(g=>g.open=true));
  root.querySelector('[data-collapse]').addEventListener('click',()=>groups.forEach(g=>g.open=false));
  root.querySelector('[data-tools]').hidden=false;
  window.addEventListener('beforeprint',()=>{
    record.querySelectorAll('details').forEach(d=>{d.dataset.printOpen=String(d.open);d.open=true;});
    record.querySelectorAll('[hidden]').forEach(e=>{e.dataset.printHidden='true';e.hidden=false;});
  });
  window.addEventListener('afterprint',()=>{
    record.querySelectorAll('details').forEach(d=>{d.open=d.dataset.printOpen==='true';});
    record.querySelectorAll('[data-print-hidden]').forEach(e=>{e.hidden=true;delete e.dataset.printHidden;});
  });
}
document.querySelectorAll('[data-education]').forEach(enhanceEducation);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-education]').forEach(enhanceEducation));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sean-experience"] && !Shopify.designMode) return;
  try {
    function enhanceExperience(root) {
  if (root.dataset.enhanced) return;
  const resume = root.querySelector('#resume');
  if (!resume) return;
  root.dataset.enhanced = 'true';
  const overview = document.createElement('h2');
  overview.textContent = root.querySelector('.sb-exp__content').dataset.overview;
  resume.querySelector('.page-header').prepend(overview);
  const links = [...root.querySelectorAll('[data-group]')];
  const groups = [...resume.querySelectorAll('.accordion > details')];
  groups.forEach((group, index) => {
    group.id = 'exp-' + links[index].dataset.group;
    group.open = true;
    const intro = document.createElement('p');
    intro.className = 'sb-exp__group-intro';
    intro.textContent = links[index].dataset.intro;
    group.querySelector(':scope > summary').after(intro);
    const photo = group.querySelector('.role h3 img');
    if (photo) {
      const oldHeading = photo.parentElement;
      const figure = document.createElement('figure');
      figure.className = 'sb-exp__military-image';
      figure.append(photo);
      intro.after(figure);
      if (!oldHeading.textContent.trim()) oldHeading.remove();
    }
    group.querySelectorAll(':scope > article.role').forEach(role => {
      const heading = role.querySelector('h3');
      if (!heading) return;
      const detail = document.createElement('details');
      detail.className = 'sb-exp__role';
      const summary = document.createElement('summary');
      summary.append(heading);
      const meta = role.querySelector(':scope > .meta');
      if (meta) summary.append(meta);
      const body = document.createElement('div');
      body.className = 'sb-exp__role-body';
      while (role.firstChild) body.append(role.firstChild);
      detail.append(summary, body);
      role.append(detail);
    });
  });
  root.querySelector('.sb-exp__tools').hidden = false;
  root.querySelector('[data-expand]').addEventListener('click', () => resume.querySelectorAll('details').forEach(d => { d.open = true; }));
  root.querySelector('[data-collapse]').addEventListener('click', () => {
    resume.querySelectorAll('.sb-exp__role, .accordion > details > details').forEach(d => { d.open = false; });
    groups.forEach(d => { d.open = true; });
  });
  root.querySelectorAll('.sb-exp__aside a').forEach(link => link.addEventListener('click', () => {
    const target = root.querySelector(link.getAttribute('href'));
    if (target?.tagName === 'DETAILS') target.open = true;
  }));
  window.addEventListener('beforeprint', () => {
    resume.querySelectorAll('details').forEach(d => { d.dataset.beforePrintOpen = String(d.open); d.open = true; });
  });
  window.addEventListener('afterprint', () => {
    resume.querySelectorAll('details').forEach(d => { d.open = d.dataset.beforePrintOpen === 'true'; });
  });
}
document.querySelectorAll('[data-experience]').forEach(enhanceExperience);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-experience]').forEach(enhanceExperience));
  } catch(e) { console.error(e); }
})();

})();
